import { Component, OnInit, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { CcLineSummaryDto } from '../../../data/models/cc-line-summary-dto';
import { CCLineDetailsNotesDto } from '../../../data/models/ccline-details-notes-dto';
import { LineDetailsDto } from '../../../data/models/line-details-dto';
import { AccountLineSubjectService } from '../../../services/account-line-subject.service';
import { CcPortalService } from '../../../services/cc-portal.service';
import { LineDetailsService } from '../../../services/line-details.service';
import { StatusClassService } from '../../../services/status-class.service';
import { DialogService } from '../../../services/dialog.service';

@Component({
  selector: 'app-cc-line-summary',
  templateUrl: './cc-line-summary.component.html',
  styleUrls: ['./cc-line-summary.component.scss'],
  providers: [MessageService, DialogService]
})
export class CcLineSummaryComponent implements OnInit {
  @Input() lineId: number;
  
  @Input() lineSummary: CcLineSummaryDto;
  @Input() isPair: boolean;
  @Input() pairNum: number;
  ccNotes: string;
  loader: boolean = true;
  lineSpeed: string;
  showSubmitTicket: boolean = false;

  constructor(private ccPortalService: CcPortalService, private messageService: MessageService
    , private lineDetailsServcie: LineDetailsService, private accountLineChangesService: AccountLineSubjectService
    , private statusClassServcie: StatusClassService, private dialogService: DialogService) { }

  ngOnInit() {
    //if (this.lineSummary) {

    //  if (this.isPair && this.pairNum>0)
    //           this.lineSummary.fakeName += "  (Pair - " + this.pairNum+") ";


    //}
    this.calcLineSpeed(this.lineSummary?.lineSpeed);
    this.loader = false;
    this.dialogService.onCloseDialog().subscribe(() => {
      this.showSubmitTicket = false; // Close the dialog
    });
  }
  ngOnChanges() {
    this.calcLineSpeed(this.lineSummary?.lineSpeed);
  }
    

  getViewClass(line) {
    return this.statusClassServcie.getViewClass(line);
    
  }

  getSeverity(status: any) {
    return this.statusClassServcie.getTextClass(status);
  
  }

  calcLineSpeed(numberInput) {
    let gZeroes = 1000000;
    let mZeroes = 1000;
    let fractionZeroesNumber = 100;

    if (numberInput >= gZeroes) {
      this.lineSpeed = Math.round((numberInput / gZeroes) * fractionZeroesNumber) / fractionZeroesNumber  + " Gbps";
    }
    else if (numberInput >= mZeroes) {
      this.lineSpeed = Math.round((numberInput / mZeroes) * fractionZeroesNumber) / fractionZeroesNumber + " Mbps";
    }
    else this.lineSpeed = Math.round(numberInput * fractionZeroesNumber) / fractionZeroesNumber + " kbps";
  }

  goToCreateTicket() {
    this.showSubmitTicket = true;
  }
  onDialogTicketsClose(event) {
   // console.log("inside onDialogTicketsClose , event = ",event)
    this.showSubmitTicket = false;
    if (event.isSuccess) {
      this.messageService.add({ severity: 'success', summary: 'Ticket Created Successfully', detail: event.resultDescription + ' with SR Number = ' + event.srNumber });
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'Create New Ticket', detail: event.resultDescription });

    }

    
  }
}
